import "./styles.scss";

import React, { useState, useRef } from "react";
import { useMediaQuery } from "react-responsive";
import { AnimatePresence, motion } from "framer-motion";

import Mobile from "./Mobile";
import CategoriesContent from "./Content";

import { useHamburger } from "context/hamburger";

const Categories = ({ selected }) => {
  const { isCategoriesOpen, setIsCategoriesOpen } = useHamburger();

  const innerRef = useRef(null);
  const isMobile = useMediaQuery({
    query: "(max-width: 991px)",
  });

  const [dropdown, setDropdown] = useState(null);
  const [dropdownHeight, setDropdownHeight] = useState(0);

  const hideDropdown = () => setDropdown(null);
  const handleDropdownHeight = () => {
    const inner = innerRef.current;

    if (inner) setDropdownHeight(inner.clientHeight);
  };

  return (
    <>
      <div className="blog-main__filters__categories">
        <div
          className="blog-main__filters__categories__actions"
          role="presentation"
          onMouseLeave={hideDropdown}
        >
          <div className="blog-main__filters__categories__actions-buttons">
            <button
              className="has-arrow"
              type="button"
              onClick={() => setIsCategoriesOpen(true)}
              onMouseEnter={
                !!isMobile ? () => {} : () => setDropdown("category")
              }
            >
              Filtracja: {selected?.name || "Pokaż wszystkie wpisy"}
              <span />
            </button>
          </div>
          <AnimatePresence>
            {dropdown && (
              <motion.div
                className="blog-main__filters__categories__actions-dropdown"
                style={{ "--dropdown-height": dropdownHeight + "px" }}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ type: "tween", duration: 0.3 }}
              >
                <AnimatePresence exitBeforeEnter>
                  <motion.div
                    key={dropdown}
                    ref={innerRef}
                    className="blog-main__filters__categories__actions-dropdown-inner"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{ type: "tween", duration: 0.3 }}
                    onAnimationStart={(definition) => {
                      if (definition.opacity === 1) handleDropdownHeight();
                    }}
                  >
                    <CategoriesContent
                      title="Która kategoria wpisów Cię interesuje?"
                      selected={selected}
                    />
                  </motion.div>
                </AnimatePresence>
              </motion.div>
            )}
          </AnimatePresence>
        </div>
      </div>
      {isCategoriesOpen && (
        <Mobile
          isOpen={isCategoriesOpen}
          onClose={() => setIsCategoriesOpen(false)}
        />
      )}
    </>
  );
};

export default Categories;
